import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgAlertInfo: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 102 102" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#404040" cx={51} cy={51} r={51} />
      <path
        d="M49.62 78.39s-2.41 1.52-4.07 1.5l-.23.11v-.1c-.34-.02-.7-.06-1.05-.15l-.52-.12c-2.88-.67-4.41-3.37-3.7-6.1l4.02-15.29 1.82-6.9c1.68-6.41-5.35 1.36-6.8-1.6-.95-1.94 5.48-6.04 10.17-9.13 0 0 2.42-1.52 4.07-1.5l.24-.11v.1c.34.02.69.06 1.04.14l.52.13c2.9.67 4.65 3.43 3.93 6.15l-4.01 15.3-1.82 6.9c-1.69 6.4 5.23-1.4 6.68 1.56.95 1.95-5.6 6.02-10.29 9.1zm10.17-47.7a7 7 0 11-13.58-3.38 7 7 0 0113.58 3.38z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgAlertInfo;
